import React from "react";
import { Link } from "react-router-dom";
import HomeInteractive from "./HomeInteractive.js";

const CropYield = () => {
  return (
    <>
      {/* CropYield page for interactive module for future use  */}
      <HomeInteractive />
      <div className="text-center">
        <h1 className="text-xl md:text-4xl my-10">Available soon</h1>
      </div>
    </>
  );
};

export default CropYield;
